// DONOT TOUCH
window.addEventListener("DOMContentLoaded", (event) => {
  try{
     let websitePath = location.pathname;
  if(location.pathname.includes('/en-int')){
     websitePath = location.pathname.split('/en-int')[1];
  }
  else if(location.pathname.includes('/en-us')){
     websitePath = location.pathname.split('/en-us')[1];
  }
  else if(location.pathname.includes('/en-ae')){
     websitePath = location.pathname.split('/en-ae')[1];
  }

  fetch(`${window.location.origin}/browsing_context_suggestions.json`)
    .then((response) => response.json())
    .then((result) => {
   
      if (result.detected_values.country.handle !== Shopify.country) {
      
        if (result.detected_values.country.handle == "US") {
          window.location.href =
            `${window.shopUrl}/en-us`+
            websitePath;
        } else if (result.detected_values.country.handle == "IN") {
          window.location.href =
           `${window.shopUrl}` +
            websitePath;
        } 
         else if (result.detected_values.country.handle == "AE") {
          window.location.href =
           `${window.shopUrl}/en-ae` +
            websitePath;
        }else if (
          result.detected_values.country.handle != "IN" &&
          result.detected_values.country.handle != "US"  &&
          result.detected_values.country.handle != "AE"
        ) {
           if (!(location.pathname.includes('/en-int'))) {
            window.location.href =
              `${window.shopUrl}/en-int` +
              websitePath;
           }
        }
      }
     if (result.detected_values.country.handle == "IN") {
        document.cookie =
          "customLocalization=IN; expires=Fri, 31 Dec 9999 23:59:59 GMT";
        document.cookie =
          "pricePercentage= N/A; expires=Fri, 31 Dec 9999 23:59:59 GMT";
       localStorage.setItem('customLocalization','IN');
       localStorage.setItem('pricePercentage', 1);
       
      }  else if (result.detected_values.country.handle == "AE") {
        document.cookie =
          "customLocalization=AE; expires=Fri, 31 Dec 9999 23:59:59 GMT";
        document.cookie =
          "pricePercentage= 0.20; expires=Fri, 31 Dec 9999 23:59:59 GMT";
       
        localStorage.setItem('customLocalization','AE');
        localStorage.setItem('pricePercentage', 1.20);
       
      } else if (result.detected_values.country.handle == "US") {
        document.cookie =
          "customLocalization=US; expires=Fri, 31 Dec 9999 23:59:59 GMT";
        document.cookie =
          "pricePercentage= 0.15; expires=Fri, 31 Dec 9999 23:59:59 GMT";

        localStorage.setItem('customLocalization','US');
        localStorage.setItem('pricePercentage', 1.15);
      }
      else{
          document.cookie =
          "customLocalization=INT; expires=Fri, 31 Dec 9999 23:59:59 GMT";
          document.cookie =
          "pricePercentage= 0.15; expires=Fri, 31 Dec 9999 23:59:59 GMT";

        localStorage.setItem('customLocalization','INT');
        localStorage.setItem('pricePercentage', 1.15);
      }
    
    })
    .catch((error) => console.log("error", error));
  }
 catch(e){
   console.log("error", e)
 }
 

});
